import React from 'react';
import PropTypes from 'prop-types';

import { numberWithCommas } from '../utils/convert';

const Money = ({
  amount,
  prefix,
  fromCents,
}) => {
  const fc = money => (money ? money / 100 : 0);
  let loan = amount;
  if (fromCents) {
    const money = fc(amount);
    loan = numberWithCommas(money);
  }
  return (
    <span className="Money">
      {prefix && <span className="prefix">{prefix}</span>}
      {loan}
    </span>
  );
};

Money.propTypes = {
  amount: PropTypes.number,
  fromCents: PropTypes.bool,
  prefix: PropTypes.string,
};

Money.defaultProps = {
  amount: 0,
  fromCents: false,
  prefix: null,
};

export default Money;



// WEBPACK FOOTER //
// ./src/components/Money.jsx